import React from 'react';
import { withPendingTradesContainer } from '../../../containers/default';
import SaleTable from './SaleTable';
import ConfirmationModal from './ConfirmationModal';

const PendingSaleTrades = (props) => {
  const {
    page,
    saleTrade,
    pendingSaleTrades,
    pendingPagination,
    isTradeSelected,
    onAcceptSaleTrade,
    onRejectSaleTrade,
    onToggleAcceptModal,
    onUnToggleAcceptModal,
    onPageChange,
  } = props;

  return (
    <div className="contracts-layout-content">
      <SaleTable
        trades={pendingSaleTrades}
        pagination={pendingPagination}
        onAccept={onToggleAcceptModal}
        onReject={onRejectSaleTrade}
        onPageChange={onPageChange}
        page={page}
      />

      <ConfirmationModal
        selected={isTradeSelected}
        saleTrade={saleTrade}
        onAcceptSaleTrade={onAcceptSaleTrade}
        onUnselectObject={onUnToggleAcceptModal}
      />
    </div>
  );
};

export default withPendingTradesContainer(PendingSaleTrades);
